// Utils
import { replaceAllInString } from '../string/replaceAllInString';
import { memoize } from '../others/memoize';
import { stripEscapedWords } from '../string/stripEscapedWords';
// Types
import { PHP_TO_DATE_FNS_FORMAT_TOKEN_MAP } from './types/PHP_TO_DATE_FNS_FORMAT_TOKEN_MAP';
/**
 * @description Converts a date/time formatted with php and converts it to date-fns
 *
 * @param {string} format The string to convert to date-fns format
 * @returns {string} date-fns formatted date/time string
 */
export var convertPhpDateTimeFormatToDateFns = memoize(function (format) {
    return replaceAllInString(stripEscapedWords(format), PHP_TO_DATE_FNS_FORMAT_TOKEN_MAP);
});
//# sourceMappingURL=convertPhpDateTimeFormatToDateFns.js.map